import React, { Component } from "react";

import { connect } from "react-redux";
import { Col, Row, Container } from "react-bootstrap";

import { updateTutorSettings } from "../../../apis/tutors";
import { EditHeadComponent } from "../BioAndSubEditComponent";
import { TutorSettingAction } from "./../../../redux/actions";

import AddDetailModal from "../../../components/modals/AddDetail.Modal";
import OtherReasonsModal from "../../../components/modals/OtherReasons.Modal";
import PauseProfileModal from "../../../components/modals/PauseProfile.Modal";
import ProfileStatusModal from "../../../components/modals/ProfileStatus.Modal";
import TutoringWorthModal from "../../../components/modals/TutoringWorth.Modal";

class ProfileStatus extends Component {

	constructor() {
		super();

		this.state = {
			endDate: "",
			disable: true,
			isOpen: false,
			startDate: "",
			disableSave: true,
			offlineDetails: {},
			profileStatus: null,
			ModalAddress: false,
			tutoringWorth: false,
			modalTimePicker: false,
			otherReasonsModal: false,
		};

	}

	selectReason = (reason) => {
		let { offlineDetails, disable } = this.state;
		offlineDetails.reasonForLeaving = reason;
		this.setState({ reason, offlineDetails });
		if (disable) {
			this.setState({ disable: false });
		}
	}

	componentDidMount = () => {
		const { tutorSettingData } = this.props;
		this.setState({
			profileStatus: tutorSettingData?.tutorDetails?.profileStatus,
			offlineDetails: tutorSettingData?.tutorDetails?.offlineDetails
				? tutorSettingData?.tutorDetails?.offlineDetails
				: {
					reasonForLeaving: "",
					offlineStartDate: "",
					offlineEndDate: "",
					optionSelected: 1,
					moreDetail: "",
				},
		});
	}

	componentDidUpdate = (prevProps) => {
		const { tutorSettingData } = this.props;
		const { offlineDetails, profileStatus } = this.state;

		if (
			JSON.stringify(tutorSettingData) !==
			JSON.stringify(prevProps.tutorSettingData)
		) {
			this.setState({
				profileStatus: tutorSettingData?.tutorDetails?.profileStatus,
				offlineDetails: tutorSettingData?.tutorDetails?.offlineDetails
					? tutorSettingData?.tutorDetails?.offlineDetails
					: {
						reasonForLeaving: "",
						offlineStartDate: "",
						offlineEndDate: "",
						optionSelected: 1,
						moreDetail: "",
					},
			});
		}
	}

	onSave = () => {
		let { tutorSettingData } = this.props;
		let { offlineDetails, profileStatus } = this.state;
		tutorSettingData = tutorSettingData ? tutorSettingData : {};
		if (tutorSettingData?.tutorDetails) {
			tutorSettingData.tutorDetails.profileStatus = profileStatus;
			tutorSettingData.tutorDetails.offlineDetails = offlineDetails;
		} else {
			tutorSettingData.tutorDetails = {};
			tutorSettingData.tutorDetails.profileStatus = profileStatus;
			tutorSettingData.tutorDetails.offlineDetails = offlineDetails;
		}
		this.props.TutorSettingStoreData(tutorSettingData);
		let updateSettingParam = {
			updateSetting: {
				profileStatus,
				offlineDetails
			},
		};
		updateTutorSettings(updateSettingParam)
			.then((res) => {
				this.setState({
					loader: false,
				});
				this.props.history.push("/tutor-dashboard/TutorSettingBioAndSub");
			})
			.catch((err) => {
				console.log(err);
				this.setState({
					loader: false,
				});
			});
	}

	goLive = () => {

		const { disableSave } = this.state;

		if (disableSave) {

			this.setState({ profileStatus: 0, disableSave: false })

		}
		else this.setState({ profileStatus: 0 })

	}

	nextButton = () => {

		const { reason } = this.state;

		if (reason === "Tutoring isn't worth time and money") {

			this.setState({ isOpen: false, tutoringWorth: true, disable: true });

		}
		else if (reason === "I am going away, I won't to able to reply to new queries") {

			this.setState({ isOpen: false, modalTimePicker: true });

		}
		else if (reason === "I have other reasons") {

			this.setState({ isOpen: false, otherReasonsModal: true, tutoringWorth: false });

		}
		else this.setState({ isOpen: false, ModalAddress: true, tutoringWorth: false });

	}

	render() {

		const {
			isOpen,
			disable,
			disableSave,
			ModalAddress,
			profileStatus,
			tutoringWorth,
			offlineDetails,
			modalTimePicker,
			otherReasonsModal
		} = this.state;

		return (

			<Container>
				<Row className="flex-col-center">
					<Col lg={8} md={9} sm={10} xs={11} className="ProfileBio-of-setting-div profile-status">

						<EditHeadComponent
							isBorder={false}
							settingTitle={"Profile status"}
							profileStatus={profileStatus === 0 ? "Live" : "Offline"}
							backToprofileView={() => this.props.history.push("/tutor-dashboard/TutorSettingBioAndSub")}
							settingDescription={profileStatus === 0
								? "Your profile will appear in search results for lesson request based on your availability."
								: "Remove your tutor profile from search results. You can go live anytime."
							}
						/>

						<h5 className="change-listing">Change your tutor profile listing</h5>

						<ProfileStatusPanel
							simpleTxt={"Live"}
							onClick={this.goLive}
							profileStatus={profileStatus === 0}
							liveSigh={require("./../../../assets/icons/greenCircle.svg")}
							desc={"Your profile will appear in search result for lesson request based on your availability"}
						/>

						<ProfileStatusPanel
							simpleTxt={"Offline"}
							profileStatus={profileStatus === 1}
							onClick={() => this.setState({ isOpen: true })}
							liveSigh={require("./../../../assets/icons/away.png")}
							desc={"Remove your tutor profile from search results. You can go live anytime."}
						/>

						<span className="link">What do the different status mean?</span>

						<hr className="hr" />

						<button className="save" onClick={this.onSave} disabled={disableSave}>
							Save
						</button>

						<button className="cancel" onClick={() => this.props.history.goBack()}>
							Cancel
						</button>

					</Col>

					<ProfileStatusModal
						isOpen={isOpen}
						disable={disable}
						nextButton={this.nextButton}
						offlineDetails={offlineDetails}
						selectReason={this.selectReason}
						onHide={() => this.setState({ isOpen: false })}
					/>

					<TutoringWorthModal
						disable={disable}
						isOpen={tutoringWorth}
						nextButton={this.nextButton}
						offlineDetails={offlineDetails}
						selectReason={this.selectReason}
						onHide={() => this.setState({ tutoringWorth: false, isOpen: true, disable: false })}
						goBack={() => this.setState({ isOpen: true, tutoringWorth: false, disable: false })}
					/>

					<AddDetailModal
						isOpen={ModalAddress}
						offlineDetails={offlineDetails}
						onHide={() => this.setState({ ModalAddress: false })}
						goBack={() => this.setState({ isOpen: true, ModalAddress: false })}
						onChange={(e) => {
							offlineDetails.moreDetail = e.target.value;
							this.setState({ offlineDetails });
						}}
						GoOffline={() =>
							this.setState({
								isOpen: false,
								ModalAddress: false,
								profileStatus: 1,
								disableSave: false,
							})
						}
					/>

					<OtherReasonsModal
						isOpen={otherReasonsModal}
						offlineDetails={offlineDetails}
						onHide={() => this.setState({ otherReasonsModal: false })}
						goBack={() => this.setState({ isOpen: true, otherReasonsModal: false })}
						onChange={(e) => {
							offlineDetails.moreDetail = e.target.value;
							this.setState({ offlineDetails });
						}}
						GoOffline={() =>
							this.setState({
								isOpen: false,
								otherReasonsModal: false,
								profileStatus: 1,
								disableSave: false,
							})
						}
					/>

					<PauseProfileModal
						isOpen={modalTimePicker}
						endDate={offlineDetails?.offlineEndDate}
						startDate={offlineDetails?.offlineStartDate}
						onHide={() => this.setState({ modalTimePicker: false })}
						goBack={() => this.setState({ isOpen: true, modalTimePicker: false })}
						onChangeDate={(date, rangetxt) => {
							offlineDetails[rangetxt] = new Date(date).getTime();
							this.setState({ offlineDetails });
						}}
						GoOffline={() =>
							this.setState({
								isOpen: false,
								modalTimePicker: false,
								profileStatus: 1,
								disableSave: false,
							})
						}
					/>

				</Row>
			</Container>

		);
	}

}

const ProfileStatusPanel = ({ desc, onClick, liveSigh, simpleTxt, profileStatus }) => {

	return (

		<div onClick={onClick} className={`profile-status-panel ${profileStatus ? "active" : ""}`}>
			<div><img src={liveSigh} /></div>
			<div>
				<h4>{simpleTxt}</h4>
				<p>{desc}</p>
			</div>
		</div>

	);

};

const mapDispatchToprops = (dispatch) => {
	return {
		TutorSettingStoreData: (payload) =>
			dispatch(TutorSettingAction.TutorSettingStoreData(payload)),
	};
};

const mapStateToProps = (state) => {
	const {
		TutorSettingReducer: { tutorSettingData },
	} = state;
	return {
		tutorSettingData,
	};
};

export default connect(mapStateToProps, mapDispatchToprops)(ProfileStatus);
